// extracted by css-extract-rspack-plugin
var _1 = "close__Qwen5";
var _2 = "debug__KA9Kl";
var _3 = "error__TfPZ4";
var _4 = "icon__hCBFb";
var _5 = "info__zuisb";
var _6 = "message__VfbBh";
var _7 = "success__a1B0E";
var _8 = "warning__gAPMb";
export { _1 as "close", _2 as "debug", _3 as "error", _4 as "icon", _5 as "info", _6 as "message", _7 as "success", _8 as "warning" }
export default { "close": _1, "debug": _2, "error": _3, "icon": _4, "info": _5, "message": _6, "success": _7, "warning": _8 }
